import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
import { useInstance } from 'intact-vue-next';
export function useCheck(_ref) {
  var getEnabledData = _ref.getEnabledData,
    getShowedData = _ref.getShowedData;
  var instance = useInstance();
  var startIndex = undefined;
  var endIndex = undefined;
  var checked = false;
  function selectAll(model) {
    var _context;
    var keyName = instance.get('keyName');
    instance.set(model + "CheckedKeys", _mapInstanceProperty(_context = getEnabledData(model)).call(_context, function (item) {
      return item[keyName];
    }));
  }
  function isCheckAll(model) {
    var checked = instance.get(model + "CheckedKeys");
    var data = getEnabledData(model);
    return data.length && checked.length >= data.length;
  }
  function toggleCheckAll(model, e) {
    if (e.target.checked) {
      selectAll(model);
    } else {
      instance.set(model + "CheckedKeys", []);
    }
  }
  function isIndeterminate(model) {
    var checked = instance.get(model + "CheckedKeys");
    var data = getEnabledData(model);
    return checked.length > 0 && checked.length < data.length;
  }
  function onCheckboxChange(model, index, e) {
    if (startIndex === undefined || !e.shiftKey) {
      startIndex = index;
      endIndex = undefined;
      checked = e.target.checked;
    } else if (e.shiftKey) {
      var _context2;
      e.preventDefault();
      var values = getShowedData(model);
      var checkedKeys = _sliceInstanceProperty(_context2 = instance.get(model + "CheckedKeys")).call(_context2, 0);
      var lastEndIndex = endIndex;
      var keyName = instance.get('keyName');
      endIndex = index;
      var update = function update(data, isCheck) {
        data.forEach(function (item) {
          if (!item.disabled) {
            var key = item[keyName];
            var _index = checkedKeys.indexOf(key);
            if (isCheck) {
              if (!~_index) {
                checkedKeys.push(key);
              }
            } else {
              if (~_index) {
                _spliceInstanceProperty(checkedKeys).call(checkedKeys, _index, 1);
              }
            }
          }
        });
      };
      if (lastEndIndex !== undefined) {
        // if exists lastEndIndex, we reset the last result
        // and set it again
        update(_sliceInstanceProperty(values).call(values, Math.min(index, lastEndIndex), Math.max(index, lastEndIndex) + 1), !checked);
      }
      update(_sliceInstanceProperty(values).call(values, Math.min(index, startIndex), Math.max(index, startIndex) + 1), checked);
      instance.set(model + "CheckedKeys", checkedKeys);
    }
  }
  return {
    isCheckAll: isCheckAll,
    toggleCheckAll: toggleCheckAll,
    onCheckboxChange: onCheckboxChange,
    isIndeterminate: isIndeterminate
  };
}